if (typeof Object.assign != 'function') {
  Object.assign = function(target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

var desktopWidth = 800;

//Slider functions
function run_slide_progress(slider, slide_index, total_time, animation_window_var){
	var interval = 10;
	var iterations = (total_time-300) / interval;
	var current_iteration = 0;
	var selectors = $(slider).siblings('.slide-selectors');		
	var selector = selectors.find($('.slide-selector[data-slide="'+slide_index+'"]'));

	//Reset progress bars ahead of current index
	selectors.find('span.progress').each(function(){
		var liIndex = $(this).parents('li').index();
		if (slide_index <= liIndex){
			$(this).css({width: 0});
		} else{
			$(this).css({width: '100%'});
		}
	});
	
	window[animation_window_var] = setInterval(function(){
		var width = (current_iteration / iterations) * 100;
		selector.find('span.progress').css({width: width+'%'});	
		current_iteration++;
		if (current_iteration >= iterations){
			clearInterval(window[animation_window_var]);
		}
	}, interval);
	
}
function change_slide_caption(slider, index){
	var captions = $(slider).siblings('.slide-captions');
	var nextActive = captions.find('p[data-slide-caption="'+index+'"]');
	if (nextActive.length) nextActive.addClass('active');
}
function initSlick(slider, i){
	
	$(slider).find('img[data-lazy-src]').each(function(){
		if($(this).attr('src') == ""){
			lzsrc=$(this).attr('data-lazy-src');
			$(this).attr('src', lzsrc);			
		}
	})
	i = i || 0;
	$(slider).on('init', function(){
		run_slide_progress(slider, 0, slideTime, 'animation_'+i);
	});
	
	$(slider).on('beforeChange', function(slick, slide, index){	
		var captions = $(slider).siblings('.slide-captions');
		console.log(captions);
		var currentActive = captions.find('p.active');
		console.log(currentActive);
		currentActive.removeClass('active');
	});
	
	$(slider).on('afterChange', function(slick, slide, index){
		run_slide_progress(slider, index, slideTime, 'animation_'+i);
		change_slide_caption(slider, index);
	});
	var slideTime = $(slider).attr('data-autoplaySpeed') || 4000;
	
	$(slider).slick({
		arrows:false,
		dots: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: slideTime,
		speed: 1000,
		fade: true,
		cssEase: 'linear'				
	});
	
	$(slider).siblings('.slide-selectors').on('click', '.slide-selector', function(e){
		e.preventDefault();
		clearInterval(window['animation_'+i]);
		$('span.progress').css({width: 0});
		var index = $(this).attr('data-slide');
		$(slider).slick( "slickGoTo", index );
	});

}

$(document).ready(function(){
	/*
	$('.slide-selector').on('click', function(e){
		e.preventDefault();
		clearInterval(window.animation);
		$('span.progress').css({width: 0});
		var index = $(this).attr('data-slide');
		$(this).siblings('.image-slider').slick( "slickGoTo", index );
	});
	*/
	/*
	var stickyNav = $('.sticky-nav');
	if (stickyNav.length){
		var sitckyTop = stickyNav.offset().top;	
	}*/
	
	var sliders = $('.image-slider');
	var wTop = $(this).scrollTop();
	    wH = $(window).height(),
	    WBot = wTop + wH;
	    wHalf = wTop + (wH/2);
	    
	function initSliders(sliders, wHalf){
		 $.each(sliders, function(i, slider){	
		    if(!$(slider).hasClass('slick-initialized')){
			    if (wHalf > $(slider).offset().top){
					initSlick(slider, i);
				}
		    }
		});
	}
	initSliders(sliders, wHalf);
	
	$(window).on('scroll', function(){

		var wTop = $(this).scrollTop();
	    wH = $(window).height(),
	    WBot = wTop + wH;
	    wHalf = wTop + (wH/2);
		initSliders(sliders, wHalf);
		/*
	    if(stickyNav.length){
		    var stickyBottom = $('.stop-sticky-nav').length ? $('.stop-sticky-nav').offset().top : false;
			if (wHalf > sitckyTop)stickyNav.addClass('sticky');
			else stickyNav.removeClass('sticky');			    

			if(wHalf > stickyBottom+60) stickyNav.addClass('hidden');
			else stickyNav.removeClass('hidden');
	    }
	    */
	   
		if($(window).width() > desktopWidth){
			$('.split-block-row').each(function(){
			
				// if($(this).attr('data-index')!= 2) return;
				
				var image = $(this).find('.split-block-image');		
				var text= $(this).find('.split-block-text');		
						
		
				var top = $(this).offset().top;
				var sticky = wTop >= (top - 0);
				var bottom = WBot >= (top+$(this).outerHeight()); 	
	
				
				if (wTop > top){
					image.removeClass('bottom').removeClass('sticky');
				}
				
				if (sticky && !bottom){
					if (!image.hasClass('sticky')) image.addClass('sticky');
					if (image.hasClass('bottom')) image.removeClass('bottom');
				}
				else if (bottom){
					if (!image.hasClass('bottom')) image.addClass('bottom');
					if (image.hasClass('sticky')) image.removeClass('sticky');
				}
				else{
					image.removeClass('bottom').removeClass('sticky');
				}
	   
			});
		}
	});
	
});
	


$(document).ready(function(){
	/*
	if($('.banner-slider').length){
		$('.banner-slider').slick({
			arrows:false,
			dots: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 4000,
			speed: 500,
			fade: true,
			cssEase: 'linear'
		});
	}
	*/
	
	$('.brands-nav ul li a').on('click', function(e){
		
		e.preventDefault();
		if($(this).hasClass('active')) return;
		
		//Change acitve nav item
		$('.brands-nav ul li a.active').removeClass('active');
		$(this).addClass('active');
		
		//Change active content item
		$('.brands-content .split-block-row.active').each(function(){
			$(this).removeClass('active');
			$(this).find('.split-block-image').removeClass('sticky');
		});
		var index = $(this).attr('data-index');

		$('.brands-content .split-block-row[data-index="'+index+'"]').addClass('active');
		$('.brands-content .split-block-row[data-index="'+index+'"]').find('.split-block-image').removeClass('sticky');
		
		var st = $(window).scrollTop();
		console.log(st);
		console.log( $('.brands').offset().top);
		var brandsTop =  $('.brands').offset().top;
		var brandsBottom = brandsTop + $('.brands').outerHeight();
		if(st > brandsTop){
			$('html, body').animate({scrollTop: $('.brands').offset().top - 120}, 300);
		}

		
	});
});

function servicesModalContent(id, data, callback){
	data = data || {};
	if(!id) return false;
	var endpoint = document.location.protocol+'//'+document.location.hostname+'/wp-json/services/'+id;
	$.getJSON(endpoint, function(result){
		data = Object.assign(data, result);
		var showStyle = data.image ? 'display:block' : 'display:none';			
		var prevStyle = data.prev ? 'display:block' : 'display:none';			
		var nextStyle = data.next ? 'display:block' : 'display:none';			
		var template = $('#service-modal-content').text();
		template = template.replace('{title}', data.title);
		template = template.replace('{img_src}', data.image);
		template = template.replace('{show_style}', showStyle);
		template = template.replace('{content}', data.content);
		template = template.replace('{next}', data.next);
		template = template.replace('{prev}', data.prev);
		template = template.replace('{category}', data.category);
		template = template.replace('{next_style}', nextStyle);
		template = template.replace('{prev_style}', prevStyle);
		$('.service-modal .overlay-content').html(template);
		$('.overlay').scrollTop(0);
		if (callback) callback();
	});
}

function toggleModal(el){
	if (el.hasClass('open')){
		$('body').removeClass('overlay-open');
		el.removeClass('open');
		el.find('.overlay-content').addClass('transition');
	}
	else {
		$('body').addClass('overlay-open');
		el.addClass('open');
		el.find('.overlay-content').removeClass('transition');
	}
}

function getServiceGroupNav(el, id){
	var listNav = JSON.parse(el.attr('data-list-nav'));
	//listNav.unshift('faq');
	
	var i = listNav.indexOf(parseInt(id));
	var prev = i === 0 ? null : listNav[i - 1];
	var next = i+1 === listNav.length ? null : listNav[i + 1];
	return {
		prev:prev,
		next:next,
	}
}
function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
$(window).load(function(){
	var queryVars = getUrlVars();
	if(queryVars['overlay']){
		link = $('a[data-slug="'+queryVars['overlay']+'"]');
		if(!link.length) link = $('a[data-id="'+queryVars['overlay']+'"]');	
		if(!link.length) return;
		link.trigger('click');
		history.pushState(null, "", location.href.split("?")[0]);

	}

});
$(document).ready(function(){
		$('#menu-toggle, .mobile-menu-closer').on('click', function(e){
		e.preventDefault();
		$('body').toggleClass('menu-open');
	});
	$('a.overlay-toggle').on('click', function(e){
		e.preventDefault();
		$('.overlay').removeClass('open');
		var overlay = $($(this).attr('href'));
		overlay.scrollTop(0);
		toggleModal(overlay);
	});
	$('a.service-toggle').on('click', function(e){
		e.preventDefault();
		var block = $(this).parents('.block-services')
		var category = block.attr('data-service-list');
		var id = $(this).attr('data-id');
		var nav = getServiceGroupNav(block, id);
		
		var data = {
			category: category,
			prev: nav.prev,
			next: nav.next,
		}
		
		servicesModalContent(id, data, function(){
			toggleModal($('.service-modal'));
		});		
	});

	$('.overlay').on('click', '.service-nav-link', function(e){
		e.preventDefault();
		var category = $(this).parents('.overlay-content').find('.service-type').html();
		var id = $(this).attr('data-id');
		var block = $('.block-services[data-service-list="'+category+'"]');
		var nav = getServiceGroupNav(block, id);
		
		var data = {
			category: category,
			prev: nav.prev,
			next: nav.next,
		}
		$('.overlay-content').addClass('transition');
		setTimeout(function(){
			servicesModalContent(id, data, function(){
				$('.overlay-content').removeClass('transition');
			});	
		}, 300);
	});
	$('.overlay').on('click', '.overlay-closer', function(e){
		e.preventDefault();
		toggleModal($(this).parents('.overlay'));
	});
	$('body').on('click', function(e){
		var target = $(e.target);
		if(target.hasClass('overlay-toggle')) return;		

		if (!$(this).hasClass('overlay-open') || target.is('.overlay') || target.parents('.overlay').length) return;
		console.log('made it');
		var openOverlay = $('.overlay.open');
		toggleModal(openOverlay);
	});

	$('a.btn:not(.no-arrow), a.arrow').append('<i class="fal fa-arrow-right"></i>');
	
	if ($('#map').length){
	    var script = document.createElement('script');
	    script.src = "//maps.googleapis.com/maps/api/js?callback=initialize&key=AIzaSyAC-jdOtlnqUkePs1a0V6hhFC6uvdwbXgk";
	    document.body.appendChild(script);	
	}
	function changeWords(){
		$('.word-rotator .active-out').removeClass('active-out');
		var words = $('.word-rotator span');
		var activeItem = $('.word-rotator').find('span.active');
		var activeIndex = activeItem.index();
		var nextActive = activeIndex + 1;
		nextActive = nextActive >= words.length ? 0 : nextActive;
		activeItem.removeClass('active').addClass('active-out');
		words.eq(nextActive).addClass("active");
	}
	if($('.word-rotator').length){		
		setTimeout(function(){
			changeWords();			
			setInterval(function(){
				changeWords();
			}, 5000);
		}, 2000);
	}

	
		
});
		
function initialize() {
	var eoam = {lat: 37.786740, lng:-122.410820}
	var map;
	var mapOptions = {
	  zoom:17,
	  center: eoam,
	  scrollwheel: false,
	  styles: [
		{
			featureType:'poi.business',
			stylers: [
				{ visibility: "off" }
			] 
		}
	  ],
	};
	
	var contentString = '<div id="content"><h5>Arya Derm Office</h5><p>459 Geary, Suite 400</p></div>';
	var infowindow = new google.maps.InfoWindow({
		content: contentString
	});
 
	map = new google.maps.Map(document.getElementById("map"), mapOptions);       
	var image = document.location.protocol+'//'+document.location.hostname+'/wp-content/themes/arya/dist/images/map-marker.png';
	var marker = new google.maps.Marker({
		position: eoam,
		map: map,
		icon:image,
	});   
	
      
	var contentString = '<div id="content"><h5>Parking Garage</h5><p>45 Shannon Street</p></div>';
	var infowindow2 = new google.maps.InfoWindow({
		content: contentString
	});
	var parking = {lat: 37.786458, lng:-122.412311};
	var image = document.location.protocol+'//'+document.location.hostname+'/wp-content/themes/arya/dist/images/parking-marker.png';	
	var marker2 = new google.maps.Marker({
		position: parking,
		map: map,
		icon:image,
	});  
	
	
	marker.addListener('click', function() {
		infowindow2.close();
		infowindow.open(map, marker);
	});
	
	marker2.addListener('click', function() {
		infowindow.close();
		infowindow2.open(map, marker2);
	});     
    
}

$(window).on('load', function(){
	$('.banner-slider-container').addClass('loaded');
	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var header = $('header.banner');
	var navbarHeight = header.outerHeight();
	hasScrolled();


		$(window).scroll(function(event){
		    didScroll = true;
		});
		
		setInterval(function() {
		    if (didScroll) {
		        hasScrolled();
		        didScroll = false;
		    }
		}, 250);
	
	
	function hasScrolled() {
		var brandsTop = $('.brands').length ? $('.brands').position().top : null;
		var brandsBottom = brandsTop + $('.brands').outerHeight();
	    var st = $(this).scrollTop();
	    
	    if (st > navbarHeight){
			header.addClass('scrolled');    
			header.find('a.btn').removeClass('dark-bg');
	    }else{
		    header.removeClass('scrolled');    
		    if(header.hasClass('front-page'))
				header.find('a.btn').addClass('dark-bg');    
	
	    }
	    if($('.brands-nav').length){
			if(st > brandsTop && st < brandsBottom){
				$('.brands-nav').addClass('fixed');
			}else{
				$('.brands-nav').removeClass('fixed');
			}
			    
	    }
	    
	
	    // Make sure they scroll more than delta
	    if(Math.abs(lastScrollTop - st) <= delta)
	        return;
	    
	    if($(window).width() > 800){
		    // If they scrolled down and are past the navbar, add class .nav-up.
		    // This is necessary so you never see what is "behind" the navbar.
		    if (st > lastScrollTop && st > navbarHeight){
		        // Scroll Down
		        header.removeClass('nav-down').addClass('nav-up');
		    } else {
		        // Scroll Up
		        if(st + $(window).height() < $(document).height()) {
		            header.removeClass('nav-up').addClass('nav-down');
		        }
		    }
	    }
	    
	    lastScrollTop = st;
	}
	
});

